<template>
  <div class="replay-search-wrap">
    <el-form ref="form" :model="model" :inline="true" :rules="rules">
      <el-form-item :label="'回放速度' | translateTo" prop="speed">
        <el-select v-model="model.speed">
          <el-option label="1x" :value="1" />
          <el-option label="1.5x" :value="1.5" />
          <el-option label="2x" :value="2" />
          <el-option label="5x" :value="5" />
          <el-option label="10x" :value="10" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="validateEvent" :loading="loading">
          {{ '回放' | translateTo }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    validateEvent() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('replay', this.model);
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style></style>
